var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChooseFormIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 7,
    fill: "url(#paint0_linear_11837_2448)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(3 3)",
    fill: "url(#paint1_linear_11837_2448)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 9C5.75 8.17 6.42 7.5 7.25 7.5C8.08 7.5 8.75 8.17 8.75 9C8.75 9.83 8.08 10.5 7.25 10.5C6.42 10.5 5.75 9.83 5.75 9ZM5.75 15C5.75 14.17 6.42 13.5 7.25 13.5C8.08 13.5 8.75 14.17 8.75 15C8.75 15.83 8.08 16.5 7.25 16.5C6.42 16.5 5.75 15.83 5.75 15ZM7.25 19.5C6.42 19.5 5.75 20.18 5.75 21C5.75 21.82 6.43 22.5 7.25 22.5C8.07 22.5 8.75 21.82 8.75 21C8.75 20.18 8.08 19.5 7.25 19.5ZM24.25 22H10.25V20H24.25V22ZM10.25 16H24.25V14H10.25V16ZM10.25 10V8H24.25V10H10.25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11837_2448",
    x1: 30,
    y1: 15,
    x2: -4.49871e-8,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#192A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2364A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11837_2448",
    x1: 24,
    y1: 12,
    x2: -3.59897e-8,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#192A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2364A4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseFormIcon);
export default __webpack_public_path__ + "static/media/choose-form-icon.7a96750b2a65f303124a0d3db7f2f49f.svg";
export { ForwardRef as ReactComponent };